<template>
  <div class="documents">
    <div class="col-36">
      <WrapperCheckbox
        v-if="meta.attestationPiecesJustificatives?.$status === PropertyStatus.Required"
        id="field_attestationPiecesJustificatives"
        v-model="attestationPiecesJustificativesModel"
        :alertLabel="meta.attestationPiecesJustificatives?.$messageErreurDirty!"
        label="L'employeur atteste disposer de l'ensemble des pièces justificatives nécessaires au dépôt du contrat"
        :readonly
      />
    </div>
    <UploadFichiers />
  </div>
</template>

<script setup lang="ts">
  import { storeToRefs } from 'pinia'
  import { PropertyStatus } from '@/features/domaine/property-status'
  import { UploadFichiers } from '@/features/interface/demande/shared/components'
  import { useDemandeCPROStore } from '../../useDemandeCPROStore'

  const store = useDemandeCPROStore()
  const { setupFieldWithKey } = useDemandeCPROStore()
  const { meta, readonly } = storeToRefs(store)

  const attestationPiecesJustificativesModel = setupFieldWithKey<boolean>('attestationPiecesJustificatives', true)
</script>

<style scoped lang="less">
  .documents {
    display: flex;
    flex-direction: column;
    gap: @spacing-25;
    height: 100vh;

    &__section {
      display: flex;
      flex-direction: column;
      gap: @spacing-15;

      &__button {
        width: 500px;
      }
    }
  }
</style>
